import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Dropdown, Form, Spinner, Button, Card} from "react-bootstrap";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {
    checkMarketplaceAvailabilityApi,
    fetchAssignmentsForThisBook,
    fetchCurrentUserBooks, getBookDataUrlApi, getFullBookDataUrlApi,

    updateBook
} from "../../http/bookAPI";
import AvatarEditor from 'react-avatar-editor';
import defaultImage from "../../assets/empty-cover.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Row from "react-bootstrap/Row";
import Loader from "../Loader";
import {getRedirectUrlApi} from "../../http/userAPI";
import { findReviewerPenNameConflict, ReviewerNameSafetyModal } from "../../helpers/ReviewerNameSafety";

const EditBookInDashboard = observer(({ bookData, onUpdate }) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [originalCover, setOriginalCover] = useState(null);
    const [grabAttempts, setGrabAttempts] = useState(0);

    const [showEditor, setShowEditor] = useState(false);
    const [scale, setScale] = useState(1);
    const editorRef = useRef(null);
    const submitInFlightRef = useRef(false);
    const [editorSize, setEditorSize] = useState({ width: 272, height: 410 });


    const [titleState, setTitleState] = useState(bookData?.title || '');
    const [subtitleState, setSubTitleState] = useState(bookData?.subtitle || '');
    const [authorState, setAuthorState] = useState(bookData?.author || '');
    const [summaryState, setSummaryState] = useState(bookData?.summary || '');
    const [coverPreview, setCoverPreview] = useState(null);
    const [coverFileState, setCoverFileState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reviewerSafetyConflict, setReviewerSafetyConflict] = useState(null);
    const [bookFormat, setBookFormat] = useState("6x9");

    const [paperbackAsinState, setPaperBackAsinState] = useState( '');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');
    const [assignmentsForThisBook, setAssignmentsForThisBook] = useState([]);
    const [selectedWordCount, setSelectedWordCount] = useState("");
    const [description, setDescription] = useState("");

    const [tempPDFFileE, setTempPDFFileE] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [manuscriptUploadState, setManuscriptUploadState] = useState('idle');
    const [pdfFileTitle, setPdfFileTitle] = useState("")
    const [pdffile, setPdfFile] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [fullGrabbedData, setFullGrabbedData] = useState({});
    const [kindlePriceState, setKindlePriceState] = useState('');
    const [paperbackPriceState, setPaperbackPriceState] = useState('');
    const [hardcoverPriceState, setHardcoverPriceState] = useState('');
    const [fourthPriceState, setFourthPriceState] = useState('');
    const [loadingPriceSave, setLoadingPriceSave] = useState(false);

    const [territoriesMode, setTerritoriesMode] = useState("WORLDWIDE"); // WORLDWIDE | MARKETPLACES
    const [availableMarketplaces, setAvailableMarketplaces] = useState([]);
    const [showMarketplaces, setShowMarketplaces] = useState(false);
    const [checkingMarketplaces, setCheckingMarketplaces] = useState(false);
    const [marketplaceCheckAttempts, setMarketplaceCheckAttempts] = useState(0);


    const MARKETPLACE_OPTIONS = [
        { code: 'com', label: 'Amazon.com (US)' },
        { code: 'co.uk', label: 'Amazon.co.uk (UK)' },
        { code: 'ca', label: 'Amazon.ca (CA)' },

        { code: 'de', label: 'Amazon.de (DE)' },
        { code: 'fr', label: 'Amazon.fr (FR)' },
        { code: 'it', label: 'Amazon.it (IT)' },
        { code: 'es', label: 'Amazon.es (ES)' },

        { code: 'co.jp', label: 'Amazon.co.jp (JP)' },
        { code: 'com.au', label: 'Amazon.com.au (AU)' },
        { code: 'in', label: 'Amazon.in (IN)' },

        { code: 'com.mx', label: 'Amazon.com.mx (MX)' },
        { code: 'com.br', label: 'Amazon.com.br (BR)' },
    ];


    const parentRef = useRef(null);

    const parseMarketplacesValue = (v) => {
        if (!v) return [];
        if (Array.isArray(v)) return v.filter(Boolean);

        const s = String(v).trim();
        if (!s) return [];

        if (s.startsWith("[") && s.endsWith("]")) {
            try {
                const arr = JSON.parse(s);
                return Array.isArray(arr) ? arr.filter(Boolean) : [];
            } catch {}
        }

        return s
            .split(/[,;|\n]+/g)
            .map((x) => x.trim())
            .filter(Boolean);
    };

    const getFirstAvailableAmazonAsin = () => (
        kindleAsinState ||
        paperbackAsinState ||
        hardcoverAsinState ||
        audioAsinState ||
        audibleAsinState ||
        bookData?.kindle_asin ||
        bookData?.paper_back_asin ||
        bookData?.hard_cover_asin ||
        bookData?.audio_asin ||
        bookData?.audio_audible_asin ||
        ''
    ).trim().toUpperCase();

    const openMarketplaceAmazonLink = async (marketplaceCode, event) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();

        const asin = getFirstAvailableAmazonAsin();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            toast.info("Add at least one ASIN before opening Amazon.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            const targetUrl = `https://www.amazon.${marketplaceCode}/dp/${asin}`;
            const response = await getRedirectUrlApi(targetUrl);
            if (response?.redirectUrl) {
                window.open(response.redirectUrl, "_blank", "noopener noreferrer");
            }
        } catch (error) {
            toast.error("Failed to open Amazon marketplace.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    const renderMarketplaceLink = (m, text = m.label) => (
        <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline text-decoration-none"
            onClick={(event) => openMarketplaceAmazonLink(m.code, event)}
        >
            {text}
        </button>
    );

    const userTariffPlan = String(user?.user?.tariff_plan || "FREE").toUpperCase();
    const isPaidUser = userTariffPlan !== "FREE";
    const isExistingLiveBook = String(bookData?.status || "").toUpperCase() === "LIVE";
    const savesDirectly = isPaidUser && isExistingLiveBook;


    useEffect(() => {
        if (!book?.selectedCurrentUserBook?.id) return;

        const loadAssignments = async () => {

            try {
                const data = await fetchAssignmentsForThisBook(book.selectedCurrentUserBook.id);
                setAssignmentsForThisBook(data);
            } catch (error) {
                console.error("Error loading assignments:", error);
            } finally {

            }
        };

        loadAssignments();
    }, [book?.selectedCurrentUserBook?.id, assignmentsForThisBook.length]);

    const [noManuscript, setNoManuscript] = useState(
        (bookData?.book_download || '').toUpperCase() === 'NO_MANUSCRIPT'
    );
    const [publicCatalogVisible, setPublicCatalogVisible] = useState(
        bookData?.public_catalog_visible !== false
    );

    const wordCountOptions = [
        { id: 1, count: 1000, label: "About 1,000" },
        { id: 2, count: 5000, label: "About 5,000" },
        { id: 3, count: 10000, label: "About 10,000" },
        { id: 4, count: 15000, label: "About 15,000" },
        { id: 5, count: 20000, label: "About 20,000" },
        { id: 6, count: 25000, label: "About 25,000" },
        { id: 7, count: 30000, label: "About 30,000" },
        { id: 8, count: 35000, label: "About 35,000" },
        { id: 9, count: 40000, label: "About 40,000" },
        { id: 10, count: 45000, label: "About 45,000" },
        { id: 11, count: 50000, label: "About 50,000" },
        { id: 12, count: 60000, label: "About 60,000" },
        { id: 13, count: 75000, label: "About 75,000" },
        { id: 14, count: 85000, label: "About 85,000" },
        { id: 15, count: 100000, label: "About 100,000" },
        { id: 16, count: 120000, label: "More then 120,000" },

    ];



    useEffect(() => {
        if (bookData) {
            setTitleState(bookData.title || '');
            setSubTitleState(bookData.subtitle || '');
            setAuthorState(bookData.author || '');
            setSummaryState(bookData.summary || '');
            setPaperBackAsinState(bookData.paper_back_asin || '');
            setKindleAsinState(bookData.kindle_asin || '');
            setHardCoverAsinState(bookData.hard_cover_asin || '');
            setAudioAsinState(bookData.audio_asin || '');
            // setTempPDFFile(bookData.book_temp_file || '');
            setPdfFileTitle(bookData.book_download || '');
            setTempPDFFileE('');
            setUploadProgress(0);
            setPdfFile(null);
            setManuscriptUploadState('idle');
            setMarketplaceCheckAttempts(0);
            setCoverPreview(`${process.env.REACT_APP_API_URL}covers/${bookData.cover_file}`);
            setAudibleAsinState(bookData.audio_audible_asin || '');
            setAudioBookLinkState(bookData.audio_download_link_ned || '');
            setNewBook(bookData)
            setKindlePriceState( bookData.kindle_list_price_on_amazon_decimal ? Number(bookData.kindle_list_price_on_amazon_decimal).toFixed(2) : '');
            setPaperbackPriceState( bookData.paper_back_list_price_on_amazon_decimal ? Number(bookData.paper_back_list_price_on_amazon_decimal).toFixed(2) : '');
            setHardcoverPriceState( bookData.hard_cover_list_price_on_amazon_decimal ? Number(bookData.hard_cover_list_price_on_amazon_decimal).toFixed(2) : '');
            setFourthPriceState( bookData.fourth_list_price_on_amazon_decimal ? Number(bookData.fourth_list_price_on_amazon_decimal).toFixed(2) : '');

            if (bookData?.booksLanguageId) {
                const selectedLang = book.languages.find(lang => lang.id === bookData.booksLanguageId);
                if (selectedLang) {
                    book.setSelectedLanguage(selectedLang);
                }
            }
            setNoManuscript((bookData?.book_download || '').toUpperCase() === 'NO_MANUSCRIPT');
            setPublicCatalogVisible(bookData?.public_catalog_visible !== false);
            if (bookData?.booksGenreId) {
                const selectedGen = book.genres.find(gen => gen.id === bookData.booksGenreId);
                if (selectedGen) {
                    book.setSelectedGenre(selectedGen);
                }
            }
            setNewBook({
                paper_back_flag: bookData?.paper_back_flag || false,
                kindle_flag: bookData?.kindle_flag || false,
                kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
                hard_cover_flag: bookData?.hard_cover_flag || false,
                audio_flag: bookData?.audio_flag || false,
                audio_exclusive_flag: bookData?.audio_exclusive_flag || false,
                audio_non_exclusive_flag: bookData?.audio_non_exclusive_flag || false,
            });
            const totalWords = Number(book?.selectedCurrentUserBook?.total_words);

            const mpArr = parseMarketplacesValue(bookData?.available_marketplaces);
            if (mpArr.length > 0) {
                setTerritoriesMode("MARKETPLACES");
                setAvailableMarketplaces(mpArr);
                setShowMarketplaces(false);
            } else {
                setTerritoriesMode("WORLDWIDE");
                setAvailableMarketplaces([]);
                setShowMarketplaces(false);
            }

            if (totalWords) {
                const matchedOption = wordCountOptions.find(opt => opt.count === totalWords);
                if (matchedOption) {
                    setSelectedWordCount(matchedOption);
                }
            }

        }
    }, [bookData?.id]);

    const bookSizes = {
        "6x9": { aspectRatio: 6 / 9 },
        "8.5x11": { aspectRatio: 8.5 / 11 },
        "8.5x8.5": { aspectRatio: 8.5 / 8.5 },
        "8x10": { aspectRatio: 8 / 10 },
        "5x8": { aspectRatio: 5 / 8 },
        "7x10": { aspectRatio: 7 / 10 },
    };

    const productSizes = {
        "1x1":  { aspectRatio: 1 },
        "4x5":  { aspectRatio: 4/5 },
        "3x4":  { aspectRatio: 3/4 },
        "2x3":  { aspectRatio: 2/3 },
        "16x9": { aspectRatio: 16/9 },
        "5x4":  { aspectRatio: 5/4 },
    };
    const isProduct = bookData?.book_type === 'product';
    useEffect(() => {
        if (bookData?.book_type === 'product') {
            setBookFormat('1x1');
        } else {
            setBookFormat('6x9');
        }
    }, [bookData?.book_type]);

    useEffect(() => {
        const updateSize = () => {
            if (!parentRef.current) return;
            const parentWidth = parentRef.current.clientWidth;

            const map = bookData?.book_type === 'product' ? productSizes : bookSizes;
            const fallbackKey = bookData?.book_type === 'product' ? '1x1' : '6x9';
            const selected = map[bookFormat] || map[fallbackKey];

            const newHeight = parentWidth / selected.aspectRatio;
            setEditorSize({ width: parentWidth, height: newHeight });
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [bookFormat, bookData?.book_type]);


    const [newBook, setNewBook] = useState(
        {
            paper_back_flag: false,
            kindle_flag: false,
            kindle_unlimited_flag: false,
            hard_cover_flag: false,
            audio_flag: false,
            audio_exclusive_flag: false,
            audio_non_exclusive_flag: false,
        }
    );

    const internalHandleClose = () => {
        if (bookData) {
            setTitleState('');
            setSubTitleState('');
            setAuthorState('');
            setSummaryState('');
            setPaperBackAsinState('');
            setKindleAsinState('');
            setHardCoverAsinState('');
            setAudioAsinState('');
            setAudibleAsinState('');
            setAudioBookLinkState('');
            setTempPDFFileE('');
            setManuscriptUploadState('idle');
            setPdfFileTitle('');
            setCoverPreview('');
            setOriginalCover(null);
            setDescription('');
            book.setSelectedLanguage({});
            book.setSelectedGenre({});
            //  book.setSelectedCurrentUserBook({});
            setNewBook({
                paper_back_flag: false,
                kindle_flag: false,
                kindle_unlimited_flag: false,
                hard_cover_flag: false,
                audio_flag: false,
                audio_exclusive_flag: false,
                audio_non_exclusive_flag: false,
            });
            setSelectedWordCount({id: 0, count: 0, label: "" });
            setHardcoverPriceState('');
            setPaperbackPriceState('');
            setKindlePriceState('');
            setFourthPriceState('');
            setFullGrabbedData({});
            setNoManuscript(false);
            setPublicCatalogVisible(true);

        }


    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setNewBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }

            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }

            if (name === "audio_flag" && !checked) {
                updatedBook.audio_exclusive_flag = false;
                updatedBook.audio_non_exclusive_flag = false;
            }

            if (name === "kindle_flag" && !checked) {
                updatedBook.kindle_unlimited_flag = false;
            }

            return updatedBook;
        });
    };

    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };

    const resetTempManuscriptUpload = () => {
        setTempPDFFileE('');
        setUploadProgress(0);
        setPdfFile(null);
        setManuscriptUploadState('idle');
    };

    const selectBookFile = (e) => {
        const input = e.target;
        const file = input.files[0];

        input.value = "";

        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const maxFileSize = 500 * 1024 * 1024; // 500MB in bytes
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        setPdfFile(file);
        setPdfFileTitle(file.name); // Save the original file name
        setTempPDFFileE('');
        setUploadProgress(0);
        setManuscriptUploadState('uploading');


        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                    if (percentComplete >= 100) {
                        setManuscriptUploadState('processing');
                    }
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {

                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;

                    toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    setTempPDFFileE(tempFileName);
                    setManuscriptUploadState('ready');
                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setTempPDFFileE('');
                    setUploadProgress(-1);
                    setManuscriptUploadState('error');
                }
            };

            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setTempPDFFileE('');
                setUploadProgress(-1);
                setManuscriptUploadState('error');
            };

            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setTempPDFFileE('');
            setUploadProgress(-1);
            setManuscriptUploadState('error');
        }
    };

    const handleUpdateBook = async (options = {}) => {
        if (submitInFlightRef.current || loading || ['uploading', 'processing', 'submitting'].includes(manuscriptUploadState)) return;
        const skipSafety = options?.skipSafety === true;

        if ((!titleState || !subtitleState || !authorState)) {
            toast.info(`Enter Title, Subtitle and Author!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;

        } else if ((!book.selectedLanguage.language || !book.selectedGenre.genre ||
                !(newBook.paper_back_flag || newBook.kindle_flag || newBook.hard_cover_flag || newBook.audio_flag))
        ) {
            toast.info(`Set Language, Genre and Type!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        else if (newBook.audio_flag && !(newBook.audio_exclusive_flag || newBook.audio_non_exclusive_flag)) {
            toast.info(`Set Contract Type for Audio Book!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (!summaryState) {
            toast.info(`Enter the Summary of Book!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (newBook.kindle_flag === true && !kindleAsinState) {
        toast.info(`Please enter a Kindle ASIN!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    } else if (newBook.paper_back_flag === true && !paperbackAsinState) {
        toast.info(`Please enter a Paperback ASIN!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    } else if (newBook.hard_cover_flag === true && !hardcoverAsinState) {
        toast.info(`Please enter a Hard Cover ASIN!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    } else if (newBook.audio_flag === true && !audioAsinState) {
        toast.info(`Please enter a Amazon Audio ASIN!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    } else if ((newBook.audio_exclusive_flag === true || newBook.audio_non_exclusive_flag === true) && !audibleAsinState) {
        toast.info(`Please enter a Audible ASIN!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    } else if (newBook.audio_non_exclusive_flag && !audioBookLinkState) {
        toast.info(`Please, enter a link to download!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        return;
    }
        if (!skipSafety) {
            const conflict = findReviewerPenNameConflict(user?.user?.amz_name, [authorState]);
            if (conflict) {
                setReviewerSafetyConflict(conflict);
                return;
            }
        }
        submitInFlightRef.current = true;
        setLoading(true);
        setManuscriptUploadState((prev) => (prev === 'ready' ? 'submitting' : prev));
        try {
            const formData = new FormData();

            // ===== Price normalization helpers =====
            const normalizePrice = (val) => {
                if (val === undefined || val === null) return '';
                let s = String(val).trim();
                if (!s) return '';

                // remove spaces and currency symbols, keep digits, comma, dot, minus
                s = s.replace(/\s+/g, '').replace(/[^\d.,-]/g, '');

                // optional: forbid negative (strip all minus)
                s = s.replace(/-/g, '');

                const lastComma = s.lastIndexOf(',');
                const lastDot   = s.lastIndexOf('.');
                if (lastComma === -1 && lastDot === -1) return s;

                // choose the rightmost of comma/dot as decimal separator
                const decPos = Math.max(lastComma, lastDot);
                const intPart  = s.slice(0, decPos).replace(/[.,]/g, ''); // remove thousands separators
                const fracPart = s.slice(decPos + 1).replace(/[.,]/g, ''); // keep only digits

                return fracPart ? `${intPart}.${fracPart}` : intPart; // "1234.56" or "1234"
            };

            const toPriceNumber = (val) => {
                const norm = normalizePrice(val);
                if (!norm) return undefined;
                const n = Number(norm);
                return Number.isFinite(n) ? n : undefined;
            };

            // ===== Price-specific append helpers (normalized) =====
            const appendPriceString = (key, value) => {
                const norm = normalizePrice(value);
                if (norm) formData.append(key, norm);
            };

            const appendPriceNumber = (key, value) => {
                const n = toPriceNumber(value);
                if (n !== undefined) formData.append(key, n);
            };


            appendPriceString("kindle_price_on_amazon", kindlePriceState);
            appendPriceString("paper_back_price_on_amazon", paperbackPriceState);
            appendPriceString("hard_cover_price_on_amazon", hardcoverPriceState);
            appendPriceString("fourth_price_on_amazon", fourthPriceState);

            appendPriceNumber('kindle_list_price_on_amazon_decimal', kindlePriceState);
            appendPriceNumber('paper_back_list_price_on_amazon_decimal', paperbackPriceState);
            appendPriceNumber('hard_cover_list_price_on_amazon_decimal', hardcoverPriceState);
            appendPriceNumber('fourth_list_price_on_amazon_decimal', fourthPriceState);

            formData.append('userId', user.user.id || bookData.userId);
            formData.append('booksGenreId', book.selectedGenre.id || bookData.booksGenreId);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id || bookData.booksLanguageId);
            formData.append('title', titleState || '');
            formData.append('subtitle', subtitleState || '');
            formData.append('author', authorState || '');
            formData.append('summary', summaryState || '');
            formData.append('paper_back_flag', newBook.paper_back_flag || false);
            formData.append('kindle_flag', newBook.kindle_flag || false);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag || false);
            formData.append('hard_cover_flag', newBook.hard_cover_flag || false);
            formData.append('audio_flag', newBook.audio_flag || false);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag || false);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag || false);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('status', savesDirectly ? 'LIVE' : 'NEW');
            formData.append('total_words', selectedWordCount?.count || 1000);
            formData.append('default_price', 500);
            formData.append('default_decrement', 0);
            formData.append('no_manuscript', noManuscript ? '1' : '0');
            formData.append('public_catalog_visible', publicCatalogVisible ? '1' : '0');

            formData.append('description_full', description || summaryState || '');
            formData.append('last_update_book_data_from_amazon_date', Math.floor(Date.now()/1000));

            if (coverFileState) {
                formData.append('cover_file', coverFileState);
            }

            if (!noManuscript && tempPDFFileE) {
                formData.append("book_download", tempPDFFileE);
            }

            formData.append("territories_mode", territoriesMode);

            if (territoriesMode === "WORLDWIDE") {
                formData.append("available_marketplaces", "[]");
            } else {
                formData.append("available_marketplaces", JSON.stringify(availableMarketplaces));
            }


            const data = await updateBook(bookData.id, formData);

            setTempPDFFileE('');
            setUploadProgress(0);
            setPdfFile(null);
            setManuscriptUploadState('done');
            if (data?.book?.book_download) {
                setPdfFileTitle(data.book.book_download);
            }

            toast.success(data.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            const foundBook = data?.book || null;
            if (foundBook) {
                book.setSelectedCurrentUserBook(foundBook);
            }
            user.setActiveComponent("BookFull");

           if (onUpdate) {
                onUpdate(foundBook);
            }

            try {
                const updatedBooks = await fetchCurrentUserBooks(user?.user?.id);
                book.setCurrentUserBooks(updatedBooks);
                const refreshedBook = updatedBooks.find(b => b.id === bookData.id);
                if (refreshedBook) {
                    book.setSelectedCurrentUserBook(refreshedBook);
                }
            } catch (refreshError) {
                console.error("Failed to refresh current user books after update:", refreshError);
            }


        } catch (e) {
            setManuscriptUploadState((prev) => (prev === 'submitting' ? 'ready' : prev));
            const errorMessage = e?.response?.data?.message || e?.message || "Error updating book!";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            submitInFlightRef.current = false;
            setLoading(false);
        }
    };

    const triggerFileInput = () => {
        document.getElementById("fileInput").click();
    };

    const handleFileChange = (e) => {
        const input = e.target;
        const file = e.target.files[0];
        input.value = "";
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;

                setCoverPreview(imageBase64);
                setShowEditor(true);


            };
            reader.readAsDataURL(file);
        }
    };

    const handleSave = () => {
        if (editorRef.current) {

            try {
                const canvas = editorRef.current.getImageScaledToCanvas();
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const editedImageBase64 = event.target.result;

                                setCoverPreview(editedImageBase64);
                                setCoverFileState(blob);
                                setShowEditor(false);




                            };
                            reader.readAsDataURL(blob);
                        } else {

                        }
                    },
                    'image/jpeg',
                    0.9
                );
            } catch (error) {

            }
        } else {

        }
    };

    const downloadAndSetCover = async (imageUrl, filenameHint = 'cover') => {
        if (!imageUrl) return;

        try {
            let got;
            try {
                got = await fetchCoverDirect(imageUrl);
            } catch {
                //   got = await fetchCoverViaProxy(imageUrl);
            }

            const file = blobToFile(got.blob, got.contentType, filenameHint);
            setCoverFileState(file);
            const base64 = await blobToBase64(file);
            setCoverPreview(base64);

        } catch (err) {
            console.error('Cover download failed:', err);
            toast.warn('Could not download cover automatically. You can upload it manually.', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const safeVal = (v) => (typeof v === 'number' && Number.isFinite(v)) ? v.toFixed(2) : '';
    const fetchCoverDirect = async (url) => {
        const resp = await fetch(url, { credentials: 'omit', mode: 'cors' });
        if (!resp.ok) throw new Error(`direct fetch failed: ${resp.status}`);
        const blob = await resp.blob();
        return { blob, contentType: blob.type || 'image/jpeg' };
    };

    const blobToFile = (blob, contentType, filenameHint = 'cover') => {
        const ext = (contentType.split('/')[1] || 'jpg').split(';')[0];
        return new File([blob], `${filenameHint}.${ext}`, { type: contentType });
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    const fmtUSD = (n) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);

    const priceSuffix = (v) => {
        const n = Number(v);
        return Number.isFinite(n) && n > 0 ? ` (${fmtUSD(n)})` : '';
    };

    const toDate = (v) => {
        if (v == null) return null;
        const n = Number(v);
        if (Number.isFinite(n)) {
            const ms = n > 1e12 ? n : n * 1000;
            return new Date(ms);
        }
        const parsed = Date.parse(v);
        return Number.isNaN(parsed) ? null : new Date(parsed);
    };

    const humanizeRelative = (inp) => {
        const d = inp instanceof Date ? inp : toDate(inp);
        if (!d) return '';
        const now = new Date();
        let diff = now.getTime() - d.getTime(); // >0 => ago
        const tense = diff >= 0 ? 'Ago' : 'From Now';
        diff = Math.abs(diff);

        const sec = Math.floor(diff / 1000);
        let n, unit;
        if (sec < 60) { n = sec; unit = 'Second'; }
        else if (sec < 3600) { n = Math.floor(sec / 60); unit = 'Minute'; }
        else if (sec < 86400) { n = Math.floor(sec / 3600); unit = 'Hour'; }
        else { n = Math.floor(sec / 86400); unit = 'Day'; }

        if (n === 0) return 'Just Now';
        return `${n} ${unit}${n !== 1 ? 's' : ''} ${tense}`;
    };

    const formatTime = (v) => {
        const d = toDate(v);
        if (!d) return '—';
        const dateStr = d.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'long', year: 'numeric', timeZone: 'Europe/Kyiv'
        });
        const timeStr = d.toLocaleTimeString('en-GB', {
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false, timeZone: 'Europe/Kyiv'
        });
        const rel = humanizeRelative(d);
        return `${dateStr} ${timeStr}${rel ? ` (${rel})` : ''}`;
    };



    const checkAmazonMarketplaces = async () => {
        if (marketplaceCheckAttempts >= 3) return;

        const payload = {
            marketplaces: MARKETPLACE_OPTIONS.map((m) => m.code),
            kindle_asin: kindleAsinState || bookData?.kindle_asin || '',
            paper_back_asin: paperbackAsinState || bookData?.paper_back_asin || '',
            hard_cover_asin: hardcoverAsinState || bookData?.hard_cover_asin || '',
            audio_asin: audioAsinState || bookData?.audio_asin || '',
            audio_audible_asin: audibleAsinState || bookData?.audio_audible_asin || '',
        };

        const hasAnyAsin = [
            payload.kindle_asin,
            payload.paper_back_asin,
            payload.hard_cover_asin,
            payload.audio_asin,
            payload.audio_audible_asin,
        ].some((asin) => /^[A-Z0-9]{10}$/i.test(String(asin || '').trim()));

        if (!hasAnyAsin) {
            toast.info("Add at least one ASIN before checking marketplaces.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            setMarketplaceCheckAttempts((prev) => prev + 1);
            setCheckingMarketplaces(true);
            const data = await checkMarketplaceAvailabilityApi(payload);
            const found = Array.isArray(data?.availableMarketplaces) ? data.availableMarketplaces : [];

            setTerritoriesMode("MARKETPLACES");
            setAvailableMarketplaces(found);
            setShowMarketplaces(true);

            if (found.length > 0) {
                toast.success(`Found availability on ${found.length} Amazon marketplace${found.length === 1 ? '' : 's'}.`, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                });
            } else {
                toast.warn("No available Amazon marketplaces were detected for the current ASINs.", {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: false,
                });
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to check Amazon marketplaces.";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 4000, hideProgressBar: false });
        } finally {
            setCheckingMarketplaces(false);
        }
    };



    const fetchAndFillPrices = async () => {
        if (grabAttempts >= 5) return;
        setGrabAttempts(prev => prev + 1);
        const asin = (kindleAsinState || paperbackAsinState || hardcoverAsinState || '').trim().toUpperCase();

        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            console.warn('Invalid ASIN:', asin);
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
            return;
        }

        const url = `https://www.amazon.com/dp/${asin}`;

        try {
            setIsLoading(true);
            const data = await getFullBookDataUrlApi(url);
            setFullGrabbedData(data || {});

            const prices = data?.prices ?? {};
            setKindlePriceState(safeVal(prices?.kindle?.value));
            setPaperbackPriceState(safeVal(prices?.paperback?.value));
            setHardcoverPriceState(safeVal(prices?.hardcover?.value));

            await downloadAndSetCover(
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '')
            );

            setTitleState(data?.title || "");
            setSubTitleState(data?.subtitle || "");
            const authorsStr = (data?.authors_str?.trim?.()) ||
                (Array.isArray(data?.authors) ? data.authors.join(", ") : "") || "";
            setAuthorState(authorsStr);

            //Description
            setSummaryState(data?.description_first10);
            setDescription(data?.description_full);

            setNewBook(prev => ({
                ...prev,
                kindle_flag: !!data?.kindle,
                kindle_unlimited_flag: !!data?.kindle_unlimited,
                paper_back_flag: !!data?.pb,
                hard_cover_flag: !!data?.hc,
                audio_flag: !!data?.audio,
                audio_exclusive_flag: !!data?.audio,
                audio_non_exclusive_flag: false,
            }));

            setKindleAsinState(data?.kindle_asin || "");
            setPaperBackAsinState(data?.pb_asin || "");
            setHardCoverAsinState(data?.hc_asin || "");
            setAudioAsinState(data?.audio_asin || "");
            setAudibleAsinState(data?.audio_audible_asin || data?.audible_asin || "");

            if (data?.main_image) {
                setCoverPreview(data.main_image);
            }

            toast.success("Cover and Prices Grabbed!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });


            const imgUrl =
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '') ||
                '';

            if (imgUrl) {
                await downloadAndSetCover(imgUrl, (data?.title || 'cover').replace(/[^\w-]+/g, '_'));
            }


        } catch (err) {
            console.error('getBookDataUrlApi error:', err);
            setKindlePriceState('');
            setPaperbackPriceState('');
            setHardcoverPriceState('');
        } finally {
            setIsLoading(false);
        }
    };

    const savePrices = async () => {
        if (loadingPriceSave) return;
        if (!bookData?.id) {
            toast.error("No book ID", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        setLoadingPriceSave(true);
        try {
            const formData = new FormData();

            // ===== Price normalization helpers =====
            const normalizePrice = (val) => {
                if (val === undefined || val === null) return '';
                let s = String(val).trim();
                if (!s) return '';

                // remove spaces and currency symbols, keep digits, comma, dot, minus
                s = s.replace(/\s+/g, '').replace(/[^\d.,-]/g, '');

                // optional: forbid negative (strip all minus)
                s = s.replace(/-/g, '');

                const lastComma = s.lastIndexOf(',');
                const lastDot   = s.lastIndexOf('.');
                if (lastComma === -1 && lastDot === -1) return s;

                // choose the rightmost of comma/dot as decimal separator
                const decPos = Math.max(lastComma, lastDot);
                const intPart  = s.slice(0, decPos).replace(/[.,]/g, ''); // remove thousands separators
                const fracPart = s.slice(decPos + 1).replace(/[.,]/g, ''); // keep only digits

                return fracPart ? `${intPart}.${fracPart}` : intPart; // "1234.56" or "1234"
            };

            const toPriceNumber = (val) => {
                const norm = normalizePrice(val);
                if (!norm) return undefined;
                const n = Number(norm);
                return Number.isFinite(n) ? n : undefined;
            };

            // ===== Price-specific append helpers (normalized) =====
            const appendPriceString = (key, value) => {
                const norm = normalizePrice(value);
                if (norm) formData.append(key, norm);
            };

            const appendPriceNumber = (key, value) => {
                const n = toPriceNumber(value);
                if (n !== undefined) formData.append(key, n);
            };

            appendPriceString("kindle_price_on_amazon", kindlePriceState);
            appendPriceString("paper_back_price_on_amazon", paperbackPriceState);
            appendPriceString("hard_cover_price_on_amazon", hardcoverPriceState);
            appendPriceString("fourth_price_on_amazon", fourthPriceState);

            appendPriceNumber('kindle_list_price_on_amazon_decimal', kindlePriceState);
            appendPriceNumber('paper_back_list_price_on_amazon_decimal', paperbackPriceState);
            appendPriceNumber('hard_cover_list_price_on_amazon_decimal', hardcoverPriceState);
            appendPriceNumber('fourth_list_price_on_amazon_decimal', fourthPriceState);


            formData.append('userId', user.user.id || bookData.userId);
            formData.append('summary', summaryState || '');
            formData.append('paper_back_flag', newBook.paper_back_flag || false);
            formData.append('kindle_flag', newBook.kindle_flag || false);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag || false);
            formData.append('hard_cover_flag', newBook.hard_cover_flag || false);
            formData.append('audio_flag', newBook.audio_flag || false);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag || false);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag || false);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('description_full', description || summaryState || '');
            formData.append('no_manuscript', noManuscript ? '1' : '0');
            formData.append('public_catalog_visible', publicCatalogVisible ? '1' : '0');
            formData.append('last_update_book_data_from_amazon_date', Math.floor(Date.now()/1000));

            if (coverFileState) {
                formData.append("cover_file", coverFileState);
            }

            const response = await updateBook(bookData.id, formData);

            setTempPDFFileE('');
            setUploadProgress(0);
            setPdfFile(null);
            setManuscriptUploadState('done');
            if (response?.book?.book_download) {
                setPdfFileTitle(response.book.book_download);
            }

            const updatedBook = response?.book || null;
            if (updatedBook) {
                book.setSelectedCurrentUserBook(updatedBook);
            }
            user?.setActiveComponent("BookFull");
            if (onUpdate) {
                onUpdate(updatedBook || response);
            }


            toast.success("Success! Price & Cover Saved! ", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            try {
                const updatedBooks = await fetchCurrentUserBooks(user?.user?.id);
                book.setCurrentUserBooks(updatedBooks);
                const refreshedBook = updatedBooks.find(b => b.id === bookData.id);
                if (refreshedBook) {
                    book.setSelectedCurrentUserBook(refreshedBook);
                }
            } catch (refreshError) {
                console.error("Failed to refresh current user books after price save:", refreshError);
            }
        } catch (err) {
            console.error("savePrices error:", err);
            const errorMessage = err?.response?.data?.message || err?.message || "Failed to save prices";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoadingPriceSave(false);
        }
    };

    const hasPrice = (v) => {
        if (v == null) return false;
        if (typeof v === 'number') return Number.isFinite(v) && v > 0;
        const s = String(v).trim();
        if (!s) return false;
        const n = Number(s.replace(',', '.'));
        return Number.isFinite(n) ? n > 0 : true;
    };

    const canSavePrices =
        !isLoading &&
        !loadingPriceSave &&
        [kindlePriceState, paperbackPriceState, hardcoverPriceState].some(hasPrice) &&
        grabAttempts > 0 &&
        grabAttempts < 3;

    const manuscriptIsBusy = ['uploading', 'processing', 'submitting'].includes(manuscriptUploadState);
    const manuscriptIsReady = manuscriptUploadState === 'ready' && Boolean(tempPDFFileE);
    const manuscriptHasError = manuscriptUploadState === 'error';


    return (
       <>
           <ReviewerNameSafetyModal
               show={!!reviewerSafetyConflict}
               conflict={reviewerSafetyConflict}
               onCancel={() => setReviewerSafetyConflict(null)}
               onContinue={() => {
                   setReviewerSafetyConflict(null);
                   handleUpdateBook({ skipSafety: true });
               }}
           />
           {loading ? (<Loader />):(
               <>
                   <Card className="p-3 w-100 mt-2">
                       <div className="small gap-2">
                           <p
                               className="small text-muted mt-1 ms-2 mb-1 d-flex flex-wrap justify-content-between align-items-center"
                               style={{ fontSize: '14px' }}
                           >
 <span className="me-2 text-truncate" style={{ maxWidth: '60%' }}>
     <h5 className="text-muted mb-0 mb-md-0">{bookData?.book_type === "product" ? "Edit Product:" : "Edit Book:"}</h5>
</span>


                               {bookData?.last_update_book_data_from_amazon_date && (<>
                                                         <span className="d-inline-flex align-items-center gap-1">
    <span className="fw-semibold text-success">{bookData?.book_type === "product" ? "Product Price Update:" : "Book Price Update:"} </span>
    <span className="fw-semibold text-muted">
      {formatTime(bookData?.last_update_book_data_from_amazon_date)}
    </span>
  </span>
                               </>  )}
                           </p>

                           <Form className="mt-0 mb-0">
                               {bookData?.book_type === 'product' ? (
                                   <>
                                       <Row className="mb-0 mt-0 p-2 small">
                                           <Col md={8}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Amazon Product Title:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter book title"
                                                       value={titleState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setTitleState(noCyrillic);
                                                       }}
                                                       onBlur={() => setTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                                       disabled={loading}
                                                       className="border "
                                                   />
                                               </Form.Group>
                                           </Col>

                                           <Col md={2}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Manufacturer:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter Product Manufacturer"
                                                       value={subtitleState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setSubTitleState(noCyrillic);
                                                       }}
                                                       onBlur={() => setSubTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                                       disabled={loading}
                                                       className="border "
                                                   />
                                               </Form.Group>
                                           </Col>

                                           <Col md={2}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Sold by:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter Seller Name"
                                                       value={authorState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setAuthorState(noCyrillic);
                                                       }}
                                                       onBlur={() => setAuthorState((v) => (v || '').replace(/:/g, '').trim())}
                                                       disabled={loading}
                                                       className="border "
                                                   />
                                               </Form.Group>
                                           </Col>
                                       </Row>
                                       {/* ===== Language / Word Count / Genre ===== */}
                                       <Row className="mb-0 p-2 flex-column flex-md-row small">
                                           <Col xs={12} md={4} className="pe-md-2 mb-2 mb-md-0">
                                               {/* Category of Product */}
                                               <Card className="p-3 border mb-0">
                                                   <div className="d-flex flex-column mt-0">
                                                       <span className="text-muted fw-semibold mb-1">Category of Product:</span>
                                                       <Dropdown>
                                                           <Dropdown.Toggle
                                                               variant="small"
                                                               size="sm"
                                                               className="w-100 border small bg-white text-start"
                                                           >
                                                               {book.selectedGenre?.genre || "Select Category"}
                                                           </Dropdown.Toggle>

                                                           <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                               {book.genres
                                                                   .filter((gen) => gen.type === "product")
                                                                   .map((gen) => (
                                                                       <Dropdown.Item
                                                                           onClick={() => book.setSelectedGenre(gen)}
                                                                           key={gen.id}
                                                                           className="small text-muted"
                                                                       >
                                                                           {gen.genre}
                                                                       </Dropdown.Item>
                                                                   ))}
                                                           </Dropdown.Menu>
                                                       </Dropdown>
                                                       <div className="d-flex flex-column mt-2 flex-md-row gap-2">

                                                           {/* Language */}
                                                           <div className="flex-grow-1">
                                                               <span className="text-muted fw-semibold mb-1 d-block">Language:</span>
                                                               <Dropdown>
                                                                   <Dropdown.Toggle
                                                                       variant="small"
                                                                       size="sm"
                                                                       className="w-100 border small bg-white text-start"
                                                                   >
                                                                       {book.selectedLanguage?.language || "Select language"}
                                                                   </Dropdown.Toggle>
                                                                   <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                                       {book.languages.map((lang) => (
                                                                           <Dropdown.Item
                                                                               onClick={() => book.setSelectedLanguage(lang)}
                                                                               key={lang.id}
                                                                               className="small text-muted"
                                                                           >
                                                                               {lang.language}
                                                                           </Dropdown.Item>
                                                                       ))}
                                                                   </Dropdown.Menu>
                                                               </Dropdown>
                                                           </div>


                                                       </div>
                                                       <div className="flex-grow-1">
  <span className="text-muted fw-semibold mt-2 mb-1 d-block">
    Select Asin's quantity:
  </span>

                                                           <Card className="p-2 mt-0 border ">
                                                               <Row>
                                                                   <Col xs={6}>
                                                                       <Form.Check
                                                                           className="custom-checkbox mb-1"
                                                                           type="checkbox"
                                                                           label="First Asin"
                                                                           name="kindle_flag"
                                                                           checked={newBook.kindle_flag}
                                                                           onChange={handleCheckboxChange}
                                                                       />
                                                                       <Form.Check
                                                                           className="custom-checkbox mb-1"
                                                                           type="checkbox"
                                                                           label="Second Asin"
                                                                           name="paper_back_flag"
                                                                           checked={newBook.paper_back_flag}
                                                                           onChange={handleCheckboxChange}
                                                                       />
                                                                   </Col>

                                                                   <Col xs={6}>
                                                                       <Form.Check
                                                                           className="custom-checkbox mb-1"
                                                                           type="checkbox"
                                                                           label="Third Asin"
                                                                           name="hard_cover_flag"
                                                                           checked={newBook.hard_cover_flag}
                                                                           onChange={handleCheckboxChange}
                                                                       />
                                                                       <Form.Check
                                                                           className="custom-checkbox mb-0"
                                                                           type="checkbox"
                                                                           label="Fourth Asin"
                                                                           name="audio_flag"
                                                                           checked={newBook.audio_flag}
                                                                           onChange={handleCheckboxChange}
                                                                       />
                                                                   </Col>
                                                               </Row>
                                                           </Card>
                                                       </div>


                                                   </div>
                                               </Card>
                                           </Col>

                                           {/* Types (Kindle/Paperback/Hardcover/Audio) */}
                                           <Col xs={12} md={8} className="px-md-2 mb-3 mb-md-0">
                                               <Card className="p-2">
                                                   <Row className="mb-2">
                                                       {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                                           <Col md={6} style={{ maxWidth: "100%" }}>
                                                               {newBook.kindle_flag && (
                                                                   <Form className="mt-0 mb-0 p-1">
                                                                       <Form.Label className="text-muted fw-semibold mb-0">First ASIN:</Form.Label>
                                                                       <div className="d-flex align-items-center">
                                                                           <Form.Control
                                                                               className="border border-secondary form-control-sm"
                                                                               value={kindleAsinState}
                                                                               onChange={(e) => {
                                                                                   const upper = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                                   setKindleAsinState(upper);
                                                                               }}
                                                                               placeholder="Enter First ASIN..."
                                                                               disabled={loading || (bookData?.kindle_asin && assignmentsForThisBook.length > 0)}
                                                                           />
                                                                           <Button
                                                                               variant="info"
                                                                               className="ms-2 btn-sm"
                                                                               disabled={!kindleAsinState}
                                                                               onClick={async () => {
                                                                                   try {
                                                                                       const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;
                                                                                       const response = await getRedirectUrlApi(targetUrl);
                                                                                       if (response?.redirectUrl) {
                                                                                           window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                       } else {
                                                                                           console.error("Failed to get redirect URL");
                                                                                       }
                                                                                   } catch (err) {
                                                                                       console.error("Redirect error:", err);
                                                                                   }
                                                                               }}
                                                                           >
                                                                               Check
                                                                           </Button>
                                                                       </div>
                                                                   </Form>
                                                               )}

                                                               {newBook.paper_back_flag && (
                                                                   <Form className="mt-0 mb-0 p-1">
                                                                       <div className="fw-semibold mb-0 text-muted">Second ASIN:</div>
                                                                       <div className="d-flex align-items-center">
                                                                           <Form.Control
                                                                               className="border border-secondary form-control-sm"
                                                                               value={paperbackAsinState}
                                                                               onChange={(e) => {
                                                                                   const cleaned = e.target.value.trim().toUpperCase();
                                                                                   setPaperBackAsinState(cleaned);
                                                                               }}
                                                                               placeholder="Enter Second ASIN..."
                                                                               disabled={loading || (bookData?.paper_back_asin && assignmentsForThisBook.length > 0)}
                                                                           />
                                                                           <Button
                                                                               variant="info"
                                                                               className="ms-2 btn-sm"
                                                                               disabled={!paperbackAsinState}
                                                                               onClick={async () => {
                                                                                   try {
                                                                                       const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;
                                                                                       const response = await getRedirectUrlApi(targetUrl);
                                                                                       if (response?.redirectUrl) {
                                                                                           window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                       } else {
                                                                                           console.error("Failed to get redirect URL");
                                                                                       }
                                                                                   } catch (err) {
                                                                                       console.error("Redirect error:", err);
                                                                                   }
                                                                               }}
                                                                           >
                                                                               Check
                                                                           </Button>
                                                                       </div>
                                                                   </Form>
                                                               )}

                                                           </Col>
                                                       )}

                                                       {/* Если первая колонка есть → вторая md=6, иначе md=8 (как у тебя было) */}
                                                       <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "100%" }}>
                                                           {newBook.hard_cover_flag && (
                                                               <Form className="mt-0 mb-0 p-1">
                                                                   <div className="fw-semibold mb-0 text-muted">Third ASIN:</div>
                                                                   <div className="d-flex align-items-center">
                                                                       <Form.Control
                                                                           className="border border-secondary form-control-sm"
                                                                           value={hardcoverAsinState}
                                                                           onChange={(e) => {
                                                                               const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                               setHardCoverAsinState(cleaned);
                                                                           }}
                                                                           placeholder="Enter Third ASIN..."
                                                                           disabled={loading || (bookData?.hard_cover_asin && assignmentsForThisBook.length > 0)}
                                                                       />
                                                                       <Button
                                                                           variant="info"
                                                                           className="ms-2 btn-sm"
                                                                           disabled={!hardcoverAsinState}
                                                                           onClick={async () => {
                                                                               try {
                                                                                   const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;
                                                                                   const response = await getRedirectUrlApi(targetUrl);
                                                                                   if (response?.redirectUrl) {
                                                                                       window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                   } else {
                                                                                       console.error("Failed to get redirect URL");
                                                                                   }
                                                                               } catch (err) {
                                                                                   console.error("Redirect error:", err);
                                                                               }
                                                                           }}
                                                                       >
                                                                           Check
                                                                       </Button>
                                                                   </div>
                                                               </Form>
                                                           )}

                                                           {newBook.audio_flag && (
                                                               <Form className="mt-0 mb-0 p-1">
                                                                   <div className="fw-semibold mb-0 text-muted">Fourth ASIN:</div>
                                                                   <div className="d-flex align-items-center">
                                                                       <Form.Control
                                                                           className="border border-secondary form-control-sm"
                                                                           value={audioAsinState}
                                                                           onChange={(e) => {
                                                                               const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                               setAudioAsinState(cleaned);
                                                                           }}
                                                                           placeholder="Enter Fourth ASIN..."
                                                                           disabled={loading || (bookData?.audio_asin && assignmentsForThisBook.length > 0)}
                                                                       />
                                                                       <Button
                                                                           variant="info"
                                                                           className="ms-2 btn-sm"
                                                                           disabled={!audioAsinState}
                                                                           onClick={async () => {
                                                                               try {
                                                                                   const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;
                                                                                   const response = await getRedirectUrlApi(targetUrl);
                                                                                   if (response?.redirectUrl) {
                                                                                       window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                   } else {
                                                                                       console.error("Failed to get redirect URL");
                                                                                   }
                                                                               } catch (err) {
                                                                                   console.error("Redirect error:", err);
                                                                               }
                                                                           }}
                                                                       >
                                                                           Check
                                                                       </Button>
                                                                   </div>
                                                               </Form>
                                                           )}
                                                       </Col>
                                                       <Row>
                                                           <Card.Body>
                                                               <Form className="m-0 mb-0">

                                                                   {/* ===== MOBILE (xs–sm): полноширинные поля и кнопки ===== */}
                                                                   <div className="d-flex d-md-none flex-column gap-2">
                                                                       {/* Цены */}
                                                                       {newBook.kindle_flag && (
                                                                           <div className="d-flex flex-column">
                                                                               <Form.Label className="text-muted fw-semibold mb-1">First Price:</Form.Label>
                                                                               <Form.Control
                                                                                   size="sm"
                                                                                   type="text"
                                                                                   inputMode="decimal"
                                                                                   pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                   placeholder="First Price"
                                                                                   value={kindlePriceState}
                                                                                   disabled={loading}
                                                                                   onChange={(e) => setKindlePriceState(e.target.value)}
                                                                               />
                                                                           </div>
                                                                       )}

                                                                       {newBook.paper_back_flag && (
                                                                           <div className="d-flex flex-column">
                                                                               <Form.Label className="text-muted fw-semibold mb-1">Second:</Form.Label>
                                                                               <Form.Control
                                                                                   size="sm"
                                                                                   type="text"
                                                                                   inputMode="decimal"
                                                                                   pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                   placeholder="Second Price"
                                                                                   value={paperbackPriceState}
                                                                                   disabled={loading}
                                                                                   onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                               />
                                                                           </div>
                                                                       )}

                                                                       {newBook.hard_cover_flag && (
                                                                           <div className="d-flex flex-column">
                                                                               <Form.Label className="text-muted fw-semibold mb-1">Third:</Form.Label>
                                                                               <Form.Control
                                                                                   size="sm"
                                                                                   type="text"
                                                                                   inputMode="decimal"
                                                                                   pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                   placeholder="Third Price"
                                                                                   value={hardcoverPriceState}
                                                                                   disabled={loading}
                                                                                   onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                               />
                                                                           </div>
                                                                       )}
                                                                       {newBook.audio_flag && (
                                                                           <div className="d-flex flex-column">
                                                                               <Form.Label className="text-muted fw-semibold mb-1">Fourth:</Form.Label>
                                                                               <Form.Control
                                                                                   size="sm"
                                                                                   type="text"
                                                                                   inputMode="decimal"
                                                                                   pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                   placeholder="Fourth Price"
                                                                                   value={fourthPriceState}
                                                                                   disabled={loading}
                                                                                   onChange={(e) => setFourthPriceState(e.target.value)}
                                                                               />
                                                                           </div>
                                                                       )}
                                                                   </div>

                                                                   {/* ===== DESKTOP (≥ md): исходная разметка без изменений ===== */}
                                                                   <div className="d-none d-md-flex flex-wrap align-items-end gap-0 mt-0 mb-0">
                                                                       {/* левая группа полей */}
                                                                       <div className="d-flex flex-wrap align-items-end gap-3 flex-grow-1">
                                                                           {newBook.kindle_flag && (
                                                                               <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                   <label className="text-muted fw-semibold">First Price:</label>
                                                                                   <Form.Control
                                                                                       size="sm"
                                                                                       type="text"
                                                                                       inputMode="decimal"
                                                                                       pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                       className="border border-secondary rounded"
                                                                                       placeholder="First Price"
                                                                                       value={kindlePriceState}
                                                                                       disabled={loading}
                                                                                       onChange={(e) => setKindlePriceState(e.target.value)}
                                                                                   />
                                                                               </div>
                                                                           )}

                                                                           {newBook.paper_back_flag && (
                                                                               <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                   <label className="text-muted fw-semibold">Second Price:</label>
                                                                                   <Form.Control
                                                                                       size="sm"
                                                                                       type="text"
                                                                                       inputMode="decimal"
                                                                                       pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                       className="border border-secondary rounded"
                                                                                       placeholder="Second Price"
                                                                                       value={paperbackPriceState}
                                                                                       disabled={loading}
                                                                                       onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                                   />
                                                                               </div>
                                                                           )}

                                                                           {newBook.hard_cover_flag && (
                                                                               <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                   <label className="text-muted fw-semibold">Third Price:</label>
                                                                                   <Form.Control
                                                                                       size="sm"
                                                                                       type="text"
                                                                                       inputMode="decimal"
                                                                                       pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                       className="border border-secondary rounded"
                                                                                       placeholder="Third Price"
                                                                                       value={hardcoverPriceState}
                                                                                       disabled={loading}
                                                                                       onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                                   />
                                                                               </div>
                                                                           )}
                                                                           {newBook.audio_flag && (
                                                                               <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                   <label className="text-muted fw-semibold">Fourth Price:</label>
                                                                                   <Form.Control
                                                                                       size="sm"
                                                                                       type="text"
                                                                                       inputMode="decimal"
                                                                                       pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                       placeholder="Fourth Price"
                                                                                       className="border border-secondary rounded"
                                                                                       value={fourthPriceState}
                                                                                       disabled={loading}
                                                                                       onChange={(e) => setFourthPriceState(e.target.value)}
                                                                                   />
                                                                               </div>
                                                                           )}

                                                                       </div>


                                                                   </div>
                                                                   <div className="text-muted" style={{ marginTop: 10, marginBottom: 0 }}>
                                                                       <p style={{ marginBottom: 0 }}>
                                                                           Pay close attention to the prices of your product variations and adjust them if necessary.
                                                                       </p>
                                                                   </div>


                                                               </Form>
                                                           </Card.Body>
                                                       </Row>

                                                   </Row>
                                               </Card>
                                           </Col>
                                       </Row>
                                       {/* COVER + UPLOAD PDF (адаптировано, все элементы с ) */}
                                       <Row className="mb-0 p-2 flex-column flex-md-row small">
                                           {/* COVER */}
                                           <Col md={4} className="mt-0">
                                               <Card className="mb-0 p-3 mt-0">
                                                   {coverPreview && (
                                                       <div className="text-center mb-0 mt-0">
                                                           {showEditor ? (
                                                               <>
                                                                   <div
                                                                       ref={parentRef}
                                                                       style={{ width: "90%", maxWidth: "500px", margin: "auto" }}
                                                                       className="mt-1"
                                                                   >
                                                                       <AvatarEditor
                                                                           ref={editorRef}
                                                                           image={coverPreview}
                                                                           width={editorSize.width}
                                                                           height={editorSize.height}
                                                                           border={0}
                                                                           scale={scale}
                                                                           borderRadius={0}
                                                                           className="text-center mb-0 mt-0 me-5 m-auto rounded"
                                                                       />

                                                                       <input
                                                                           type="range"
                                                                           min="1"
                                                                           max="2"
                                                                           step="0.005"
                                                                           value={scale}
                                                                           onChange={(e) => setScale(parseFloat(e.target.value))}
                                                                           className="form-range mt-2"
                                                                           style={{ width: "100px" }}
                                                                       />

                                                                       <Row className="d-flex align-items-center justify-content-between mt-2">
                                                                           {/* Форматы для продукта */}
                                                                           <select
                                                                               value={bookFormat}
                                                                               onChange={(e) => setBookFormat(e.target.value)}
                                                                               className="form-select w-auto form-select-sm"
                                                                               style={{ minWidth: "150px" }}
                                                                           >
                                                                               <option value="1x1">Format: 1x1</option>
                                                                               <option value="4x5">Format: 4x5</option>
                                                                               <option value="3x4">Format: 3x4</option>
                                                                               <option value="2x3">Format: 2x3</option>
                                                                               <option value="16x9">Format: 16x9</option>
                                                                               <option value="5x4">Format: 5x4</option>
                                                                           </select>

                                                                           <button
                                                                               type="button"
                                                                               className="btn btn-sm btn-success w-auto"
                                                                               onClick={handleSave}
                                                                           >
                                                                               Save Image
                                                                           </button>
                                                                       </Row>
                                                                   </div>

                                                                   <Row>{/* пусто — симметрия с книжным блоком */}</Row>
                                                               </>
                                                           ) : (
                                                               <img
                                                                   src={coverPreview}
                                                                   alt="Cover Preview"
                                                                   style={{ objectFit: "cover", borderRadius: "8px" }}
                                                                   width={300}
                                                                   className="img-fluid"
                                                               />
                                                           )}
                                                       </div>
                                                   )}
                                               </Card>

                                               <Row className="mb-3 m-lg-2 m-auto mt-3">
                                                   <div className="d-flex justify-content-center mb-0 mt-1">
                                                       <button
                                                           type="button"
                                                           className="btn btn-primary btn-sm btn-success flex-md-row me-2"
                                                           onClick={triggerFileInput}
                                                           disabled={loading}
                                                       >
                                                           Upload New Image
                                                       </button>

                                                       {/* скрытый input */}
                                                       <input
                                                           type="file"
                                                           id="fileInput"
                                                           style={{ display: "none" }}
                                                           accept="image/*"
                                                           onChange={handleFileChange}
                                                       />
                                                   </div>
                                               </Row>
                                           </Col>


                                           {/* UPLOAD PDF */}
                                           <Col md={8} className="mt-0 p-2">




                                               <Card className="mt-0">
                                                   <Card.Body>
                                                       <Row className="mb-0">
                                                           <Col>
                                                               <p className="text-start fw-semibold mb-0 text-muted">About this Product:</p>
                                                               <Form.Control
                                                                   className="p-2 border small rounded text-muted"
                                                                   as="textarea"
                                                                   rows={11}
                                                                   value={summaryState}
                                                                   onChange={e => setSummaryState(e.target.value)}
                                                                   placeholder="Enter a short and meaningful summary..."
                                                                   style={{ fontSize: 14 }}
                                                               />
                                                           </Col>
                                                       </Row>
                                                   </Card.Body>
                                               </Card>

                                           </Col>
                                       </Row>

                                   </>
                               ):(
                                   <>
                                       <Row className="mb-0 mt-0 p-2">
                                           <Col md={4}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Book Title:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter book title"
                                                       value={titleState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setTitleState(noCyrillic);
                                                       }}
                                                       onBlur={() => {
                                                           let cleaned = titleState
                                                               .replace(/[:]+$/, '')
                                                               .trim();
                                                           setTitleState(cleaned);
                                                       }}
                                                       disabled={loading}
                                                   />
                                               </Form.Group>


                                           </Col>
                                           <Col md={5}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Book Subtitle:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter book subtitle"
                                                       value={subtitleState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setSubTitleState(noCyrillic);
                                                       }}
                                                       onBlur={() => {
                                                           const cleaned = subtitleState
                                                               .replace(/[:]+$/, '')
                                                               .trim();
                                                           setSubTitleState(cleaned);
                                                       }}
                                                       disabled={loading}
                                                   />
                                               </Form.Group>


                                           </Col>
                                           <Col md={3}>
                                               <Form.Group className="mb-0">
                                                   <Form.Label className="text-muted fw-semibold mb-0">Author Name:</Form.Label>
                                                   <Form.Control
                                                       size="sm"
                                                       type="text"
                                                       placeholder="Enter author name"
                                                       value={authorState}
                                                       onChange={e => {
                                                           const raw = e.target.value;
                                                           const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                                           setAuthorState(noCyrillic);
                                                       }}
                                                       onBlur={() => {
                                                           const cleaned = authorState
                                                               .replace(/:/g, '')
                                                               .trim();
                                                           setAuthorState(cleaned);
                                                       }}
                                                       disabled={loading}
                                                   />
                                               </Form.Group>



                                           </Col>
                                       </Row>
                                       <Row className="mb-0 p-2 flex-column flex-md-row">

                                           {/* Язык и жанр */}
                                           <Col xs={12} md={4} className="pe-md-2 mb-2 mb-md-0">
                                               <div className="d-flex flex-column flex-md-row gap-2">
                                                   {/* Dropdown: Language */}
                                                   <div className="flex-grow-1">
                                                       <span className="text-muted mb-1 fw-semibold d-block">Edit Language:</span>
                                                       <Dropdown>
                                                           <Dropdown.Toggle
                                                               variant="light"
                                                               size="sm"
                                                               className="w-100"
                                                               style={{
                                                                   background: 'none',
                                                                   border: '1px solid #ced4da',
                                                                   color: '#6c757d',
                                                                   textAlign: 'left',
                                                               }}
                                                           >
                                                               {
                                                                   book.selectedLanguage?.language ||
                                                                   (book.languages.length > 0
                                                                       ? book.languages.find(lang => lang.id === bookData?.booksLanguageId)?.language
                                                                       : "Loading...")
                                                               }
                                                           </Dropdown.Toggle>
                                                           <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                               {book.languages.map(lang => (
                                                                   <Dropdown.Item
                                                                       onClick={() => book.setSelectedLanguage(lang)}
                                                                       key={lang.id}
                                                                       className="small text-muted"
                                                                   >
                                                                       {lang.language}
                                                                   </Dropdown.Item>
                                                               ))}
                                                           </Dropdown.Menu>
                                                       </Dropdown>
                                                   </div>

                                                   {/* Dropdown: Word Count */}

                                                   <div className="flex-grow-1">
                                                       <span className="text-muted fw-semibold mb-1 d-block">Edit Word Count:</span>
                                                       <Dropdown>
                                                           <Dropdown.Toggle
                                                               variant="light"
                                                               size="sm"
                                                               className="w-100"
                                                               style={{
                                                                   background: 'none',
                                                                   border: '1px solid #ced4da',
                                                                   color: '#6c757d',
                                                                   textAlign: 'left',
                                                               }}
                                                           >
                                                               {selectedWordCount?.label || "Choose..."}
                                                           </Dropdown.Toggle>
                                                           <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                               {wordCountOptions.map(option => (
                                                                   <Dropdown.Item
                                                                       key={option.id}
                                                                       onClick={() => setSelectedWordCount(option)}
                                                                       className="small text-muted"
                                                                   >
                                                                       {option.label}
                                                                   </Dropdown.Item>
                                                               ))}
                                                           </Dropdown.Menu>
                                                       </Dropdown>
                                                   </div>
                                               </div>


                                               <div className="d-flex flex-column mt-3">
                                                   <span className="text-muted fw-semibold mb-0">Edit Genre of Book:</span>
                                                   <Dropdown>
                                                       <Dropdown.Toggle
                                                           variant="light"
                                                           size="sm"
                                                           className="w-100"
                                                           style={{
                                                               background: 'none',
                                                               border: '1px solid #ced4da',
                                                               color: '#6c757d',
                                                               textAlign: 'left',
                                                           }}
                                                       >
                                                           {book?.selectedGenre?.genre || "Select Genre"}
                                                       </Dropdown.Toggle>
                                                       <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                           {book.genres.map(gen => (
                                                               <Dropdown.Item
                                                                   onClick={() => book.setSelectedGenre(gen)}
                                                                   key={gen.id}
                                                                   variant="success"
                                                                   className="small text-muted"
                                                               >
                                                                   {gen.genre}
                                                               </Dropdown.Item>
                                                           ))}
                                                       </Dropdown.Menu>
                                                   </Dropdown>
                                               </div>

                                           </Col>

                                           {/* Типы книги */}
                                           <Col xs={12} md={5} className="px-md-2 mb-3 mb-md-0">
                                               <span className="text-muted fw-semibold">Edit Available Types for this Book:</span>
                                               <Card className="p-2 mt-0">
                                                   <Form.Check
                                                       className="custom-checkbox mb-1"
                                                       type="checkbox"
                                                       label={
                                                           `This Book is Available in Kindle Version${priceSuffix(kindlePriceState)}`
                                                       }
                                                       name="kindle_flag"
                                                       checked={newBook.kindle_flag}
                                                       onChange={handleCheckboxChange}
                                                   />
                                                   <Form.Check
                                                       className="custom-checkbox mb-1"
                                                       type="checkbox"
                                                       label={

                                                           `This Book is Available in Paperback${priceSuffix(paperbackPriceState)}`

                                                       }
                                                       name="paper_back_flag"
                                                       checked={newBook.paper_back_flag}
                                                       onChange={handleCheckboxChange}
                                                   />
                                                   <Form.Check
                                                       className="custom-checkbox mb-1"
                                                       type="checkbox"
                                                       label={
                                                           `This Book is Available in Hardcover${priceSuffix(hardcoverPriceState)}`
                                                       }
                                                       name="hard_cover_flag"
                                                       checked={newBook.hard_cover_flag}
                                                       onChange={handleCheckboxChange}
                                                   />
                                                   <Form.Check
                                                       className="custom-checkbox mb-0"
                                                       type="checkbox"
                                                       label="This Book is Available in Audio Format"
                                                       name="audio_flag"
                                                       checked={newBook.audio_flag}
                                                       onChange={handleCheckboxChange}
                                                   />
                                               </Card>
                                           </Col>

                                           {/* Опции аудио и Kindle */}
                                           <Col xs={12} md={3} className="ps-md-2">
                                               {newBook.kindle_flag && (
                                                   <div>
                                                       <span className="text-muted fw-semibold mb-1">Kindle Unlimited Option?</span>
                                                       <Card className="p-2 mt-0">
                                                           <Form.Check
                                                               type="checkbox"
                                                               className="custom-checkbox mb-0"
                                                               label="Yes, it's Kindle Unlimited!"
                                                               name="kindle_unlimited_flag"
                                                               checked={newBook.kindle_unlimited_flag}
                                                               onChange={handleCheckboxChange}
                                                           />
                                                       </Card>
                                                   </div>
                                               )}

                                               {newBook.audio_flag && (
                                                   <div className="mt-2">
                                                       <span className="text-muted fw-semibold mb-1 mt-3">Type of Audio Distribution?</span>
                                                       <Card className="p-2 mt-0">
                                                           <Form.Check
                                                               type="checkbox"
                                                               className="custom-checkbox mb-1"
                                                               label="Exclusive Distribution"
                                                               name="audio_exclusive_flag"
                                                               checked={newBook.audio_exclusive_flag}
                                                               onChange={handleCheckboxChange}
                                                           />
                                                           <Form.Check
                                                               type="checkbox"
                                                               className="custom-checkbox mb-0"
                                                               label="Non-Exclusive Distribution"
                                                               name="audio_non_exclusive_flag"
                                                               checked={newBook.audio_non_exclusive_flag}
                                                               onChange={handleCheckboxChange}
                                                           />
                                                       </Card>
                                                   </div>
                                               )}
                                           </Col>

                                       </Row>
                                       <Row w={100}>

                                           <Col md={4} className="mt-0 ">
                                               <Card className="mb-0 p-3 mt-0">
                                                   {coverPreview && (

                                                       <div  className="text-center mb-0 mt-0 ">
                                                           {showEditor ? (
                                                               <>
                                                                   <div ref={parentRef} style={{ width: "90%", maxWidth: "500px", margin: "auto" }} className="mt-1">


                                                                       <AvatarEditor
                                                                           ref={editorRef}
                                                                           image={coverPreview}
                                                                           width={editorSize.width}
                                                                           height={editorSize.height}
                                                                           border={0}
                                                                           scale={scale}
                                                                           borderRadius={0}
                                                                           className="text-center mb-0 mt-0 me-5 m-auto rounded"
                                                                       />
                                                                       <input
                                                                           type="range"
                                                                           min="1"
                                                                           max="2"
                                                                           step="0.005"
                                                                           value={scale}
                                                                           onChange={(e) => setScale(parseFloat(e.target.value))}
                                                                           className="form-range mt-2"
                                                                           style={{width: '100px'}}
                                                                       />
                                                                       <Row className="d-flex align-items-center justify-content-between mt-2">
                                                                           {/* Выбор формата книги */}
                                                                           <select
                                                                               value={bookFormat}
                                                                               onChange={(e) => setBookFormat(e.target.value)}
                                                                               className="form-select w-auto form-select-sm"
                                                                               style={{minWidth: "150px"}}
                                                                           >
                                                                               <option value="6x9">Format: 6x9</option>
                                                                               <option value="8.5x11">Format: 8.5x11</option>
                                                                               <option value="8.5x8.5">Format: 8.5x8.5</option>
                                                                               <option value="8x10">Format: 8x10</option>

                                                                               <option value="5x8">Format: 5x8</option>
                                                                               <option value="7x10">Format: 7x10</option>
                                                                           </select>

                                                                           {/* Кнопка */}
                                                                           <button
                                                                               type="button"
                                                                               className="btn btn-sm  btn-success w-auto"
                                                                               onClick={handleSave}
                                                                           >
                                                                               Save Cover
                                                                           </button>


                                                                       </Row>

                                                                   </div>

                                                                   <Row>

                                                                   </Row>


                                                               </>
                                                           ) : (


                                                               <img src={coverPreview}
                                                                    alt="Cover Preview"
                                                                    style={{objectFit: 'cover', borderRadius: '8px'}}
                                                                    width={300}
                                                                    className="img-fluid"/>
                                                           )}

                                                       </div>
                                                   )}
                                               </Card>

                                               <Row  className="mb-3 m-lg-2 m-auto mt-3 ">

                                                   <div className="d-flex justify-content-center mb-0 mt-1">
                                                       <button
                                                           type="button"

                                                           className="btn btn-primary btn-sm btn-success flex-md-row me-2 "
                                                           onClick={triggerFileInput}
                                                           disabled={loading}
                                                       >
                                                           {bookData?.book_type === "product" ? "Upload New Image" : "Upload New Cover"}
                                                       </button>

                                                       <input
                                                           type="file"
                                                           id="fileInput"
                                                           style={{display: "none"}}
                                                           onChange={handleFileChange}
                                                       />


                                                   </div>
                                               </Row>


                                           </Col>

                                           <Col md={8} className="mt-0 ">
                                               <Card className="p-0">
                                                   <Row className="mb-2 p-2">
                                                       {/* Проверяем, есть ли что-то в первой колонке */}
                                                       {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                                           <Col md={6} style={{ maxWidth: "100%" }}>

                                                               {newBook.kindle_flag && (
                                                                   <Form className="mt-0 mb-0 p-1 border-success">
                                                                       <div className="text-muted fw-semibold">Kindle ASIN:</div>
                                                                       <div className="d-flex align-items-center">
                                                                           <Form.Control
                                                                               className="border border-success form-control-sm"
                                                                               value={kindleAsinState}
                                                                               onChange={e => {
                                                                                   const raw = e.target.value;
                                                                                   const upper = raw.replace(/\s/g, '').toUpperCase();
                                                                                   setKindleAsinState(upper);
                                                                               }}
                                                                               placeholder="Enter Kindle ASIN..."
                                                                               disabled={loading || (bookData?.kindle_asin && assignmentsForThisBook.length > 0)}
                                                                           />
                                                                           <Button
                                                                               variant="info"
                                                                               className="ms-2 btn-sm"
                                                                               disabled={!kindleAsinState}
                                                                               onClick={async () => {
                                                                                   try {
                                                                                       const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;

                                                                                       const response = await getRedirectUrlApi(targetUrl);

                                                                                       if (response && response.redirectUrl) {
                                                                                           window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                       } else {
                                                                                           console.error('Failed to get redirect URL');
                                                                                       }
                                                                                   } catch (err) {
                                                                                       console.error('Redirect error:', err);
                                                                                   }
                                                                               }}

                                                                           >
                                                                               Check
                                                                           </Button>
                                                                       </div>
                                                                   </Form>


                                                               )}

                                                               {newBook.paper_back_flag && (
                                                                   <Form className="mt-0 mb-0 p-1 border-success">
                                                                       <div className="text-muted fw-semibold">Paperback ASIN:</div>
                                                                       <div className="d-flex align-items-center">
                                                                           <Form.Control
                                                                               className="border border-success form-control-sm"
                                                                               value={paperbackAsinState}
                                                                               onChange={e => {
                                                                                   const raw = e.target.value;
                                                                                   const cleaned = raw.trim().toUpperCase();
                                                                                   setPaperBackAsinState(cleaned);
                                                                               }}
                                                                               placeholder="Enter Paperback ASIN..."
                                                                               disabled={loading || (bookData?.paper_back_asin && assignmentsForThisBook.length > 0)}
                                                                           />
                                                                           <Button
                                                                               variant="info"
                                                                               className="ms-2 btn-sm"
                                                                               disabled={!paperbackAsinState}
                                                                               onClick={async () => {
                                                                                   try {
                                                                                       const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;

                                                                                       const response = await getRedirectUrlApi(targetUrl);

                                                                                       if (response && response.redirectUrl) {
                                                                                           window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                       } else {
                                                                                           console.error('Failed to get redirect URL');
                                                                                       }
                                                                                   } catch (err) {
                                                                                       console.error('Redirect error:', err);
                                                                                   }
                                                                               }}

                                                                           >
                                                                               Check
                                                                           </Button>
                                                                       </div>
                                                                   </Form>

                                                               )}

                                                               {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag || newBook.audio_flag) && (
                                                                   <>
                                                                       {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag) && (
                                                                           <Form className="mt-0 mb-0 p-1 border-success">
                                                                               <div className="text-muted fw-semibold">Audible ASIN:</div>
                                                                               <div className="d-flex align-items-center">
                                                                                   <Form.Control
                                                                                       className="border border-success form-control-sm"
                                                                                       value={audibleAsinState}
                                                                                       onChange={e => {
                                                                                           const raw = e.target.value;
                                                                                           const cleaned = raw.replace(/\s/g, '').toUpperCase();
                                                                                           setAudibleAsinState(cleaned);
                                                                                       }}
                                                                                       placeholder="Enter Audible ASIN..."
                                                                                       disabled={loading || (bookData?.audio_audible_asin && assignmentsForThisBook.length > 0)}
                                                                                   />
                                                                                   <Button
                                                                                       variant="info"
                                                                                       className="ms-2 btn-sm"
                                                                                       disabled={!audibleAsinState}
                                                                                       onClick={async () => {
                                                                                           try {
                                                                                               const targetUrl = `${user?.user?.audible_country}/pd/${audibleAsinState}`;

                                                                                               const response = await getRedirectUrlApi(targetUrl);

                                                                                               if (response && response.redirectUrl) {
                                                                                                   window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                               } else {
                                                                                                   console.error('Failed to get redirect URL');
                                                                                               }
                                                                                           } catch (err) {
                                                                                               console.error('Redirect error:', err);
                                                                                           }
                                                                                       }}

                                                                                   >
                                                                                       Check
                                                                                   </Button>
                                                                               </div>
                                                                           </Form>

                                                                       )}
                                                                   </>
                                                               )}


                                                           </Col>
                                                       )}

                                                       {/* Если первая колонка есть → вторая md=6, иначе md="auto" */}
                                                       <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "100%" }}>
                                                           {newBook.hard_cover_flag && (
                                                               <Form className="mt-0 mb-0 p-1 border-success">
                                                                   <div className="text-muted fw-semibold">Hardcover ASIN:</div>
                                                                   <div className="d-flex align-items-center">
                                                                       <Form.Control
                                                                           className="border border-success form-control-sm"
                                                                           value={hardcoverAsinState}
                                                                           onChange={e => {
                                                                               const raw = e.target.value;
                                                                               const cleaned = raw.replace(/\s/g, '').toUpperCase();
                                                                               setHardCoverAsinState(cleaned);
                                                                           }}
                                                                           placeholder="Enter Hardcover ASIN..."
                                                                           disabled={loading || (bookData?.hard_cover_asin && assignmentsForThisBook.length > 0)}
                                                                       />
                                                                       <Button
                                                                           variant="info"
                                                                           className="ms-2 btn-sm"
                                                                           disabled={!hardcoverAsinState}
                                                                           onClick={async () => {
                                                                               try {
                                                                                   const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;

                                                                                   const response = await getRedirectUrlApi(targetUrl);

                                                                                   if (response && response.redirectUrl) {
                                                                                       window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                   } else {
                                                                                       console.error('Failed to get redirect URL');
                                                                                   }
                                                                               } catch (err) {
                                                                                   console.error('Redirect error:', err);
                                                                               }
                                                                           }}

                                                                       >
                                                                           Check
                                                                       </Button>
                                                                   </div>
                                                               </Form>

                                                           )}

                                                           {newBook.audio_flag && (
                                                               <Form className="mt-0 mb-0 p-1 border-success">
                                                                   <div className="text-muted fw-semibold">Amazon Audio ASIN:</div>
                                                                   <div className="d-flex align-items-center">
                                                                       <Form.Control
                                                                           className="border border-success form-control-sm"
                                                                           value={audioAsinState}
                                                                           onChange={e => {
                                                                               const raw = e.target.value;
                                                                               const cleaned = raw.replace(/\s/g, '').toUpperCase();
                                                                               setAudioAsinState(cleaned);
                                                                           }}
                                                                           placeholder="Enter Amazon Audio ASIN..."
                                                                           disabled={loading || (bookData?.audio_asin && assignmentsForThisBook.length > 0)}
                                                                       />
                                                                       <Button
                                                                           variant="info"
                                                                           className="ms-2 btn-sm"
                                                                           disabled={!audioAsinState}
                                                                           onClick={async () => {
                                                                               try {
                                                                                   const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;

                                                                                   const response = await getRedirectUrlApi(targetUrl);

                                                                                   if (response && response.redirectUrl) {
                                                                                       window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                   } else {
                                                                                       console.error('Failed to get redirect URL');
                                                                                   }
                                                                               } catch (err) {
                                                                                   console.error('Redirect error:', err);
                                                                               }
                                                                           }}

                                                                       >
                                                                           Check
                                                                       </Button>
                                                                   </div>
                                                               </Form>

                                                           )}
                                                       </Col>




                                                       <Row  className="">
                                                           <Col className="p-0">
                                                               {newBook.audio_non_exclusive_flag && (
                                                                   <Form className="mt-2 mb-0 p-0 border-success">
                                                                       <div className="ms-3 text-muted fw-semibold">Enter Link to Your Non-Exclusive
                                                                           Audio Book:
                                                                       </div>
                                                                       <div className="d-flex align-items-between">
                                                                           <Form.Control
                                                                               className="border border-success ms-3 form-control-sm"
                                                                               value={audioBookLinkState}
                                                                               onChange={e => setAudioBookLinkState(e.target.value)}
                                                                               placeholder="Enter Link to Your Non-Exclusive Audio Book... https://drive.google.com/drive/"
                                                                               disabled={loading}
                                                                           />
                                                                           <Button
                                                                               variant="info"
                                                                               className="ms-2 btn-sm"
                                                                               disabled={!audioBookLinkState}
                                                                               onClick={() => window.open(`${audioBookLinkState}`, '_blank',  'noopener noreferrer')}
                                                                           >
                                                                               Check
                                                                           </Button>
                                                                       </div>
                                                                   </Form>
                                                               )}
                                                           </Col>
                                                       </Row>
                                                   </Row>
                                               </Card>
                                               <Card className="mt-2 border border-secondary">
                                                   <Card.Header className="py-2">
<span className="text-muted">
  Choose <b>Worldwide</b> if your book or product is available on all Amazon marketplaces.
  Otherwise, select the specific marketplaces where it is available.
</span>


                                                   </Card.Header>
                                                   <Card.Body>
                                               <Col xs={12} md={12}>
                                                   {/* ROW 1: Select + availability check */}
                                                   <div className="d-flex align-items-end gap-2 flex-wrap">
                                                       <div className="d-flex flex-column align-items-start" style={{ flex: "0 0 320px", maxWidth: "100%" }}>
                                                           <label className="d-block mb-1 text-muted fw-semibold">Available Marketplaces:</label>
                                                           <Form.Select
                                                               size="sm"
                                                               className="border border-secondary text-muted"
                                                               value={territoriesMode}
                                                               onChange={(e) => {
                                                                   const v = e.target.value;
                                                                   setTerritoriesMode(v);

                                                                   if (v === "WORLDWIDE") {
                                                                       setAvailableMarketplaces([]);
                                                                       setShowMarketplaces(false);
                                                                   } else {
                                                                       setShowMarketplaces(true);
                                                                   }
                                                               }}
                                                               style={{ width: "100%" }}
                                                           >
                                                               <option value="WORLDWIDE">Worldwide</option>
                                                               <option value="MARKETPLACES">Custom marketplaces</option>
                                                           </Form.Select>
                                                       </div>

                                                       <div className="d-flex flex-column align-items-start">
                                                           <label className="d-block mb-1 text-muted fw-semibold" style={{ whiteSpace: "nowrap" }}>
                                                               Attempts: {marketplaceCheckAttempts}/3
                                                           </label>
                                                           <Button
                                                               size="sm"
                                                               variant="outline-success"
                                                               onClick={checkAmazonMarketplaces}
                                                               disabled={checkingMarketplaces || marketplaceCheckAttempts >= 3}
                                                               style={{ whiteSpace: "nowrap" }}
                                                           >
                                                               {checkingMarketplaces ? (
                                                                   <>
                                                                       <Spinner animation="border" size="sm" className="me-1" />
                                                                       Checking
                                                                   </>
                                                               ) : marketplaceCheckAttempts >= 3 ? (
                                                                   "Limit Reached"
                                                               ) : (
                                                                   "Check Availability"
                                                               )}
                                                           </Button>
                                                       </div>

                                                       {territoriesMode === "MARKETPLACES" && (
                                                           <div className="d-flex justify-content-end flex-grow-1">
                                                               <Button
                                                                   size="sm"
                                                                   variant="outline-secondary"
                                                                   onClick={() => setShowMarketplaces((s) => !s)}
                                                                   disabled={checkingMarketplaces}
                                                               >
                                                                   {showMarketplaces ? "Hide" : "Show"}
                                                               </Button>
                                                           </div>
                                                       )}
                                                   </div>

                                                   {territoriesMode === "MARKETPLACES" && (
                                                       <div className="small mt-2">
                                                           {availableMarketplaces.length === 0 ? (
                                                               <span className="text-danger fw-semibold">
                                                                   Pick at least one Amazon Marketplace
                                                               </span>
                                                           ) : (
                                                               <span className="text-muted">
                                                                   Available on:{" "}
                                                                   {availableMarketplaces.map((code, index) => {
                                                                       const marketplace = MARKETPLACE_OPTIONS.find((m) => m.code === code);
                                                                       return (
                                                                           <React.Fragment key={code}>
                                                                               {index > 0 ? ", " : ""}
                                                                               {marketplace ? renderMarketplaceLink(marketplace, `.${code}`) : `.${code}`}
                                                                           </React.Fragment>
                                                                       );
                                                                   })}
                                                                   {" "}(<b>{availableMarketplaces.length}</b> total)
                                                               </span>
                                                           )}
                                                       </div>
                                                   )}

                                                   {/* ROW 2: checklist UNDER the dropdown */}
                                                   {territoriesMode === "MARKETPLACES" && showMarketplaces && (
                                                       <div className="mt-2 border rounded p-2">
                                                           <div
                                                               className="d-grid gap-1"
                                                               style={{
                                                                   gridTemplateColumns: "repeat(2, minmax(160px, 1fr))",
                                                                   maxHeight: 160,
                                                                   overflowY: "auto",
                                                               }}
                                                           >
                                                               {MARKETPLACE_OPTIONS.map((m) => (
                                                                   <Form.Check
                                                                       key={m.code}
                                                                       type="checkbox"
                                                                       className="small text-muted mb-0"
                                                                       label={renderMarketplaceLink(m)}
                                                                       checked={availableMarketplaces.includes(m.code)}
                                                                       disabled={checkingMarketplaces}
                                                                       onChange={(e) => {
                                                                           const checked = e.target.checked;
                                                                           setAvailableMarketplaces((prev) =>
                                                                               checked
                                                                                   ? Array.from(new Set([...prev, m.code]))
                                                                                   : prev.filter((x) => x !== m.code)
                                                                           );
                                                                       }}
                                                                   />
                                                               ))}
                                                           </div>

                                                           <div className="d-flex justify-content-end gap-2 mt-2">
                                                               <Button
                                                                   size="sm"
                                                                   variant="outline-secondary"
                                                                   onClick={() => setAvailableMarketplaces([])}
                                                               >
                                                                   Clear
                                                               </Button>

                                                               <Button
                                                                   size="sm"
                                                                   variant="success"
                                                                   onClick={() => {
                                                                       if (availableMarketplaces.length === 0) return;
                                                                       setShowMarketplaces(false);
                                                                   }}
                                                                   disabled={availableMarketplaces.length === 0}
                                                                   title={availableMarketplaces.length === 0 ? "Pick at least one marketplace" : ""}
                                                               >
                                                                   Done
                                                               </Button>
                                                           </div>
                                                       </div>
                                                   )}
                                               </Col>
                                                   </Card.Body>
                                               </Card>

                                               <Card className="mt-2 border border-secondary">
                                                   <Card.Header className="py-2">
<span className="text-muted">
  Update directly from Amazon. All prices are pulled in USD from Amazon.com, and your book must be available on Amazon.com for syncing. {savesDirectly
    ? "We will save your updated cover, USD prices, formats, and book details immediately."
    : "We will refresh your cover, USD prices, formats, and book details, then send the update for moderation."}
</span>

                                                   </Card.Header>
                                                   <Card.Body>
                                                       <Form className="m-0">

                                                           {/* ===== MOBILE (xs–sm): полноширинные поля и кнопки ===== */}
                                                           <div className="d-flex d-md-none flex-column gap-2">
                                                               {/* Цены */}
                                                               {newBook.kindle_flag && (
                                                                   <div className="d-flex flex-column">
                                                                       <Form.Label className="text-muted fw-semibold mb-1">Kindle Price:</Form.Label>
                                                                       <Form.Control
                                                                           size="sm"
                                                                           type="text"
                                                                           inputMode="decimal"
                                                                           pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                           placeholder="Kindle Price"
                                                                           value={kindlePriceState}
                                                                           onChange={(e) => setKindlePriceState(e.target.value)}
                                                                           disabled={isLoading}
                                                                       />
                                                                   </div>
                                                               )}

                                                               {newBook.paper_back_flag && (
                                                                   <div className="d-flex flex-column">
                                                                       <Form.Label className="text-muted fw-semibold mb-1">Paperback:</Form.Label>
                                                                       <Form.Control
                                                                           size="sm"
                                                                           type="text"
                                                                           inputMode="decimal"
                                                                           pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                           placeholder="Paperback Price"
                                                                           value={paperbackPriceState}
                                                                           onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                           disabled={isLoading}
                                                                       />
                                                                   </div>
                                                               )}

                                                               {newBook.hard_cover_flag && (
                                                                   <div className="d-flex flex-column">
                                                                       <Form.Label className="text-muted fw-semibold mb-1">Hard Cover:</Form.Label>
                                                                       <Form.Control
                                                                           size="sm"
                                                                           type="text"
                                                                           inputMode="decimal"
                                                                           pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                           placeholder="Hardcover Price"
                                                                           value={hardcoverPriceState}
                                                                           onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                           disabled={isLoading}
                                                                       />
                                                                   </div>
                                                               )}

                                                               {/* Кнопки */}
                                                               <div className="d-grid gap-2 mt-1">
                                                                   <div className="text-muted small">Grab &amp; Save, No Moderation11</div>
                                                                   <Button
                                                                       variant="info"
                                                                       size="sm"
                                                                       disabled={isLoading}
                                                                       onClick={fetchAndFillPrices}
                                                                   >
                                                                       {isLoading ? 'Grabbing…' : 'Grab Price from Amazon'}
                                                                   </Button>
                                                                   <small className="text-muted ms-2">Attempts: {grabAttempts}/3</small>



                                                                   <Button
                                                                       variant="success"
                                                                       size="sm"
                                                                       disabled={!canSavePrices}
                                                                       onClick={savePrices}
                                                                   >
                                                                       {isLoading
                                                                           ? 'Grabbing Now'
                                                                           : loadingPriceSave
                                                                               ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />Saving…</>)
                                                                               : grabAttempts === 0
                                                                                   ? 'Run Grab First'
                                                                                   : grabAttempts >= 3
                                                                                       ? 'Grab Limit Reached'
                                                                                       : 'Save & Close'}
                                                                   </Button>

                                                               </div>
                                                           </div>

                                                           {/* ===== DESKTOP (≥ md): исходная разметка без изменений ===== */}
                                                           <div className="d-none d-md-flex flex-wrap align-items-end gap-0 mt-0">
                                                               {/* левая группа полей */}
                                                               <div className="d-flex flex-wrap align-items-end gap-3 flex-grow-1">
                                                                   {newBook.kindle_flag && (
                                                                       <div className="d-flex flex-column" style={{ minWidth: 30, maxWidth: 90 }}>
                                                                           <label className="text-muted fw-semibold">Kindle Price:</label>
                                                                           <Form.Control
                                                                               size="sm"
                                                                               type="text"
                                                                               inputMode="decimal"
                                                                               pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                               className="border border-secondary rounded"
                                                                               placeholder="Kindle Price"
                                                                               value={kindlePriceState}
                                                                               onChange={(e) => setKindlePriceState(e.target.value)}
                                                                               disabled={isLoading}
                                                                           />
                                                                       </div>
                                                                   )}

                                                                   {newBook.paper_back_flag && (
                                                                       <div className="d-flex flex-column" style={{ minWidth: 30, maxWidth: 90 }}>
                                                                           <label className="text-muted fw-semibold">Paperback:</label>
                                                                           <Form.Control
                                                                               size="sm"
                                                                               type="text"
                                                                               inputMode="decimal"
                                                                               pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                               className="border border-secondary rounded"
                                                                               placeholder="Paperback Price"
                                                                               value={paperbackPriceState}
                                                                               onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                               disabled={isLoading}
                                                                           />
                                                                       </div>
                                                                   )}

                                                                   {newBook.hard_cover_flag && (
                                                                       <div className="d-flex flex-column" style={{ minWidth: 30, maxWidth: 90 }}>
                                                                           <label className="text-muted fw-semibold">Hard Cover:</label>
                                                                           <Form.Control
                                                                               size="sm"
                                                                               type="text"
                                                                               inputMode="decimal"
                                                                               pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                               className="border border-secondary rounded"
                                                                               placeholder="Hardcover Price"
                                                                               value={hardcoverPriceState}
                                                                               onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                               disabled={isLoading}
                                                                           />
                                                                       </div>
                                                                   )}
                                                               </div>

                                                               {/* правая колонка с кнопкой — прижата вправо на ≥ md */}
                                                               <div className="ms-md-auto mt-0 mx-3 mt-md-0 d-grid" style={{ minWidth: 50, maxWidth: 200 }}>
                                                                   <label className="text-muted">Grab & Save. Attempts: {grabAttempts}/3</label>
                                                                   <Button
                                                                       variant="info"
                                                                       size="sm"
                                                                       disabled={isLoading}
                                                                       onClick={fetchAndFillPrices}
                                                                   >
                                                                       {isLoading ? 'Grabbing…' : 'Grab Cover & Price'}
                                                                   </Button>

                                                               </div>

                                                               <div className="ms-md-auto mt-0 mt-md-0 d-grid" style={{ minWidth: 10, maxWidth: 200 }}>
                                                                   <Button
                                                                       variant="success"
                                                                       size="sm"
                                                                       disabled={!canSavePrices}
                                                                       onClick={savePrices}
                                                                   >
                                                                       {isLoading
                                                                           ? 'Grabbing Now'
                                                                           : loadingPriceSave
                                                                               ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />Saving…</>)
                                                                               : grabAttempts === 0
                                                                                   ? 'Run Grab First'
                                                                                   : grabAttempts >= 3
                                                                                       ? 'Limit Reached'
                                                                                       : 'Save & Close'}
                                                                   </Button>
                                                               </div>
                                                           </div>

                                                       </Form>
                                                   </Card.Body>
                                               </Card>



                                               <Card className="mt-2">
                                                   <Card.Body>
                                                       <Row className="mb-2">
                                                           <Col>
                                                               <p className="text-start fw-semibold mb-0 text-muted">Edit Book Summary:</p>
                                                               <Form.Control
                                                                   className="p-2 border border-secondary small rounded text-muted"
                                                                   as="textarea"
                                                                   rows={4}
                                                                   value={summaryState}
                                                                   onChange={e => setSummaryState(e.target.value)}
                                                                   placeholder="Enter a short and meaningful summary for your book..."
                                                                   style={{ fontSize: 14 }}
                                                               />
                                                           </Col>
                                                       </Row>
                                                   </Card.Body>
                                               </Card>




                                               <Card className="mt-2">
                                                   <Card.Header className="py-1">
                                                       <Form.Check
                                                           type="checkbox"
                                                           id="public-catalog-visible-edit"
                                                           label={
                                                               <span className="ms-1">
                                                                   <span className="fw-semibold">
                                                                       {bookData?.book_type === 'product'
                                                                           ? 'I want to place my product in the public product store'
                                                                           : 'I want to place my book in the public book library'}
                                                                   </span>
                                                                   {publicCatalogVisible
                                                                       ? (bookData?.book_type === 'product'
                                                                           ? " — members will be able to discover it in the public product store."
                                                                           : " — Discoverable in the public ARC library.")
                                                                       : (bookData?.book_type === 'product'
                                                                           ? " — your product will not be shown in the public product store."
                                                                           : " — Your book won't be publicly listed.")}
                                                               </span>
                                                           }
                                                           checked={publicCatalogVisible}
                                                           onChange={(e) => setPublicCatalogVisible(e.target.checked)}
                                                           className="custom-checkbox mt-2 mb-1"
                                                       />
                                                   </Card.Header>
                                               </Card>

                                               <Card className="mt-2">
                                                   <Card.Header className="py-1">
                                                       <Form.Check
                                                           type="checkbox"
                                                           id="no-manuscript-edit"
                                                           label={
                                                               <span className="ms-1">
                                                        <span className="fw-semibold">I don’t want to upload the manuscript</span>
                                                                   {" — Universal assignments will be unavailable."}
                                                        </span>
                                                           }
                                                           checked={noManuscript}
                                                           onChange={(e) => {
                                                               const v = e.target.checked;
                                                               setNoManuscript(v);
                                                               if (v) {
                                                                   setPdfFileTitle('');
                                                                   resetTempManuscriptUpload();
                                                               }
                                                           }}
                                                           className="custom-checkbox mt-2 mb-1"
                                                       />
                                                   </Card.Header>
                                                   {!noManuscript && (
                                                       <Card.Body>
                                                           <Row className="mb-0">
      <span className="mx-auto text-muted mb-3 text-start fw-semibold">
        Re-upload your Book File (PDF up to 500 Mb)
      </span>

                                                               <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 w-100 mb-3">

                                                                   {/* Кнопка загрузки */}
                                                                   <div className="flex-shrink-0">
                                                                       <Button
                                                                           variant="danger"
                                                                           onClick={triggerFileInputBook}
                                                                           className="btn btn-sm px-3"
                                                                           style={{ whiteSpace: 'nowrap' }}
                                                                       >
                                                                           Upload Book File
                                                                       </Button>
                                                                   </div>

                                                                   {/* Прогресс или сохранённое имя файла */}
                                                                   <div className="flex-grow-1 w-100">
                                                                       {uploadProgress > 0 && !manuscriptHasError ? (
                                                                           <div
                                                                               className="progress mt-0"
                                                                               role="progressbar"
                                                                               aria-valuenow={uploadProgress}
                                                                               aria-valuemin={0}
                                                                               aria-valuemax={100}
                                                                               style={{
                                                                                   height: "30px",
                                                                                   borderRadius: "6px",
                                                                                   backgroundColor: "#f1f1f1",
                                                                                   overflow: "hidden",
                                                                               }}
                                                                           >
                                                                               <div
                                                                                   className={`progress-bar text-truncate px-2  ${
                                                                                       uploadProgress === 100 ? "bg-success" : "bg-info"
                                                                                   }`}
                                                                                   style={{
                                                                                       width: `${uploadProgress}%`,
                                                                                       transition: "width 0.4s ease",
                                                                                       whiteSpace: "nowrap",
                                                                                   }}
                                                                               >
                                                                                   {uploadProgress === 100 ? (
                                                                                       <span className="fw-semibold fst-normal">
                    Manuscript Ready:{" "}
                                                                                           {pdfFileTitle.length > 40
                                                                                               ? pdfFileTitle.slice(0, 40) + "..."
                                                                                               : pdfFileTitle}
                  </span>
                                                                                   ) : uploadProgress === 99 ? (
                                                                                       <span className="fw-semibold fst-normal">Processing manuscript: watermarking and compressing...</span>
                                                                                   ) : (
                                                                                       `${uploadProgress}%`
                                                                                   )}
                                                                               </div>
                                                                           </div>
                                                                       ) : manuscriptHasError ? (
                                                                           <Col className="text-center shadow-sm border border-danger rounded-1 py-1">
                                                                               <strong className="text-danger d-block">Upload failed. Please upload the PDF again.</strong>
                                                                           </Col>
                                                                       ) : pdfFileTitle ? (
                                                                           <>
                                                                               <Col className="text-center shadow-sm border border-secondary rounded-1 py-1">
                                                                                   <strong className="text-muted d-block">  Saved: {pdfFileTitle.slice(0, 30)}...</strong>
                                                                               </Col>
                                                                           </>

                                                                       ) : null}
                                                                   </div>
                                                               </div>

                                                               {/* Скрытый input */}
                                                               <Form.Group className="mb-0">
                                                                   <Form.Control
                                                                       type="file"
                                                                       accept="application/pdf"
                                                                       id="fileInputBook"
                                                                       onChange={selectBookFile}
                                                                       style={{ display: "none" }}
                                                                   />
                                                               </Form.Group>

                                                               {/* Инструкция */}
                                                               <div className="d-flex justify-content-end">
                                                                   <p className="mb-0 text-muted small fst-italic text-end">
                                                                       {manuscriptIsBusy
                                                                           ? "Processing manuscript: watermarking and compressing. Please wait..."
                                                                           : manuscriptHasError
                                                                           ? "The temporary manuscript was not created. Please upload the PDF again before saving."
                                                                           : !manuscriptIsReady && !pdfFileTitle
                                                                           ? "After uploading your book file, you'll be able to submit it for moderation."
                                                                           : (savesDirectly ? "Click Save Changes to update this live book." : "Click Submit for Moderation to send this update for review.")}
                                                                   </p>
                                                               </div>
                                                           </Row>
                                                       </Card.Body>
                                                   )}
                                               </Card>





                                           </Col>

                                       </Row>
                                   </>
                               )

                               }










                           </Form>




                           <div className="d-flex justify-content-end gap-2 mt-3">
                               <Button variant="secondary"  onClick={() => {
                                   internalHandleClose();
                                   user.setActiveComponent("MainPageDashboard");
                                   book.setSelectedCurrentUserBook({});

                               }} disabled={loading}
                                       className="btn btn-sm"
                               >Close</Button>
                               <Button variant="success"
                                       className="btn btn-sm"
                                       onClick={handleUpdateBook}
                                       disabled={loading || (manuscriptIsBusy && noManuscript === false)}>
                                   {(loading || manuscriptIsBusy) ? (
                                       <>
                                           {loading || manuscriptUploadState === 'submitting'
                                               ? "Saving Book"
                                               : manuscriptUploadState === 'processing' || uploadProgress === 99
                                               ? "Processing Manuscript"
                                               : "Uploading Your File"}&nbsp;
                                           <Spinner animation="border" size="sm" />
                                       </>
                                   ) : (
                                       savesDirectly ? 'Save Changes' : 'Submit for Moderation'
                                   )}

                               </Button>
                           </div>
                       </div>
                   </Card>
               </>
           )}

        </>

    );
});

export default EditBookInDashboard;
